import React from 'react';
import { EmailTimelineContainer} from '../../Containers/EmailContainer';

const EmailTimeline = (props) => {
	return (
		<EmailTimelineContainer />
	);
}
export default EmailTimeline;


